import { AfterViewInit, Component, ElementRef, Input, OnDestroy } from '@angular/core';
import { ControlContainer, NgForm }                                from '@angular/forms';
import $                                                           from 'jquery';

import '../../vendor/bootstrap-datepicker/bootstrap-datepicker.min';

import { CustomerStatementSettingsModel } from './typings/customer.statement-settings';
import { DateParserService }              from '../core/services/date-parser.service';

type StatementDateField   = 'as_at' | 'begin_date' | 'end_date';
type StatementSwitchField = 'include_paid' | 'statement';

type DatepickerElement = JQuery & {
  datepicker ( options : object | string ) : DatepickerElement;
};

@Component({
  selector     : 'wor-customer-statement-fields',
  template: require('./customer.statement-fields.component.html'),
  viewProviders: [
    {
      provide    : ControlContainer,
      useExisting: NgForm
    }
  ]
})
export class CustomerStatementFieldsComponent implements AfterViewInit, OnDestroy {
  @Input() settings: CustomerStatementSettingsModel;

  datePattern  = '^(\\d{1,2})/(\\d{1,2})/(\\d{4})$';
  focusedField = '';

  dateFields: Array<{ field : StatementDateField; label : string }> = [
    { field: 'begin_date', label: 'REPORT_SPACE.FIELD.BEGIN_DATE' },
    { field: 'end_date', label: 'REPORT_SPACE.FIELD.END_DATE' },
    { field: 'as_at', label: 'REPORT_SPACE.FIELD.AS_AT' }
  ];

  dates: Record<StatementDateField, string> = {
    as_at     : '',
    begin_date: '',
    end_date  : ''
  };

  switchFields: Array<{ field : StatementSwitchField; label : string }> = [
    { field: 'include_paid', label: 'REPORT_SPACE.FIELD.SHOW_PAID_TRANSACTIONS' },
    { field: 'statement', label: 'REPORT_SPACE.FIELD.30_60_90_STATEMENT' }
  ];

  constructor (
    private dateParserService: DateParserService,
    private elementRef       : ElementRef<HTMLElement>
  ) {}

  static getDefaultSettings () : CustomerStatementSettingsModel {
    return {
      as_at       : '*',
      begin_date  : '*',
      end_date    : '*',
      include_paid: true,
      statement   : false
    };
  }

  ngAfterViewInit () : void {
    this.getPickers()
      .datepicker({
        autoclose: true,
        format   : this.dateParserService.getFormat(),
        todayBtn : 'linked'
      })
      .on('changeDate', ( event : JQuery.TriggeredEvent & { date : Date } ) => {
        const field = ( event.currentTarget as HTMLElement ).dataset.field as StatementDateField;

        this.dates[ field ] = this.dateParserService.getFormat()
          .replace('dd', `${ event.date.getDate() }`)
          .replace('mm', `${ event.date.getMonth() + 1 }`)
          .replace('yyyy', `${ event.date.getFullYear() }`);

        this.updateDate(field);
      });
  }

  ngOnDestroy () : void {
    this.getPickers().datepicker('remove');
  }

  // Same conversion as the legacy report-date directive: '*' when empty, '' when invalid.
  updateDate ( field : StatementDateField ) : void {
    const value = this.dates[ field ];
    const match = value.match(new RegExp(this.datePattern));

    if ( !value ) {
      this.settings[ field ] = '*';

      return;
    }

    if ( !match ) {
      this.settings[ field ] = '';

      return;
    }

    const date = this.dateParserService.getFormat() === 'dd/mm/yyyy'
      ? new Date(`${ match[ 2 ] }/${ match[ 1 ] }/${ match[ 3 ] }`)
      : new Date(value);

    this.settings[ field ] = `${ date.getDate() }-${ date.getMonth() + 1 }-${ date.getFullYear() }`;
  }

  private getPickers () : DatepickerElement {
    return $(this.elementRef.nativeElement).find('.input-group-addon.date') as DatepickerElement;
  }
}
